import React, {Component} from 'react';

// import {Link} from 'react-router-dom';
import {HashLink as Link} from 'react-router-hash-link';
import Casilla from './../../../img/casilla.png';
import ConsejoGral from './../../../img/consejoGral_INE.png';
import ConsejosINE from './../../../img/edificioINE_circulo.png';
import OPLE from './../../../img/ople_mexico.png';
import CAEs from './../../../img/caes.png';
import TiempoCasilla from './../../../img/casillaTiempo.png';
import AccionesComunes from '../../AccionesComunes';

class QueEsSIJE extends Component {

    componentDidMount(){
        var activeMenu = document.getElementById("conoceSIJE");
        activeMenu.classList.add("active");
    }

    render () {
        return (
            <div className="container contenido">
                <AccionesComunes />
                <div className="migajas">
                    <small>
                        <Link to="./QueEsSIJE">Inicio</Link>
                        <span>Conoce el SIJE</span>
                        <span>¿Qué es el SIJE?</span>
                    </small>
                </div>
                {/* <Migajas /> */}
                <div className="col-md-12 text-center mb-5">
                    <h1 className="tituloPagina">¿Qué es el SIJE?</h1>
                    <p className="centrar">
                    Es el Sistema de Información sobre el desarrollo de la Jornada Electoral <strong>(SIJE)</strong>, es un proceso de recopilación, transmisión, captura y disposición de la información.
                    </p>
                    <p className="centrar">
                    Se implementa bajo la supervisión de cada Junta Distrital Ejecutiva del INE, con el fin de dar seguimiento, a través de una herramienta informática, a los aspectos más importantes que se presentan el día de la jornada electoral en las casillas electorales.
                    </p>
                    
                </div>
                <div className="row text-center mb-5">
                    <div className="col-md-12">
                        <h2>¿Cuál es su objetivo?</h2>
                    </div>
                    <div className="col-md-6 col-sm-12 col-sm-12">
                        <img src={Casilla} alt="casilla" />
                    </div>
                    <div className="col-md-6 col-sm-12 text-left centrar-vertical">
                        <p>
                            Informar de manera permanente y oportuna sobre el desarrollo de la Jornada Electoral.
                        </p>
                    </div>
                </div>
                <div className="row text-center mb-5">
                    <div className="col-md-12">
                        <h2>¿A quién informa?</h2>
                    </div>
                    <div className="col-md-4 col-sm-12">
                        <img src={ConsejoGral} alt="Consejo General del INE" />
                        <p><strong>Consejo General del INE</strong></p>
                    </div>
                    <div className="col-md-4 col-sm-12">
                        <img src={ConsejosINE} alt="Consejo General del INE" />
                        <p><strong>Consejos Locales y Distritales del INE</strong></p>
                    </div>
                    <div className="col-md-4 col-sm-12">
                        <img src={OPLE} alt="Consejo General del INE" />
                        <p><strong>Organismos Públicos Locales</strong></p>
                    </div>
                </div>
                {/* <div className="row text-center mb-5">
                    <div className="col-md-12">
                        <h2>¿Cómo obtiene información?</h2>
                    </div>
                    <div className="col-md-6 col-sm-12">
                        <img src={CAEs} alt="Capacitador Asistente Electoral" />
                    </div>
                    <div className="col-md-6 col-sm-12 text-left centrar-vertical">
                        <p>
                            El SIJE se nutre mediante los reportes de instalación de casilla, segundo reporte, e incidentes; los cuales son enviados por los <Link to="./Glosario#c">Capacitadores Asistentes Electorales (CAE)</Link>.
                        </p>
                    </div>
                </div>
                <div className="row text-center mb-5">
                    <div className="col-md-12">
                        <h2>¿Cuándo opera?</h2>
                    </div>
                    <div className="col-md-6 col-sm-12 text-left centrar-vertical">
                        <p>
                            Su operación se lleva a cabo el día de la Jornada Electoral. Comienza a operar antes del inicio de instalación de las casillas y termina a las 3:00am del día siguiente.
                        </p>
                    </div>
                    <div className="col-md-6 col-sm-12">
                        <img src={TiempoCasilla} alt="casilla de día a noche" />
                    </div>
                </div> */}
            </div>
        )
    }
}

export default QueEsSIJE;